import React, { Fragment, useState, useEffect } from 'react'
import Colors from '../../Assets/Styles/Colors';
//* MUI Imports
import { Box, Typography } from '@mui/material';
import { Groups, Group, Person, Work, Summarize } from '@mui/icons-material';

const RecentOrdersCard = ({ freelancer, provider, seeker, jobs, proposals }) => {
  return (
    <Box sx={{
      backgroundColor: Colors.white,
      py: "39px",
      px: 3,
      borderRadius: "12px",
      // minHeight: "220px",
      // maxHeight: "220px",
      boxShadow: "0px 0px 3px 2px #ef34343b"
    }}>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "column", gap: "16px" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "16px", }}>
            <Groups sx={{ fontSize: "48px", color: Colors.primary }} />
            <Typography>Total Service Seekers</Typography>
          </Box>
          <Typography>{seeker}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "16px", }}>
            <Group sx={{ fontSize: "48px", color: Colors.primary }} />
            <Typography>Total Service Providers</Typography>
          </Box>
          <Typography>{provider}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "16px", }}>
            <Person sx={{ fontSize: "48px", color: Colors.primary }} />
            <Typography>Total Freelancers</Typography>
          </Box>
          <Typography>{freelancer}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "16px", }}>
            <Work sx={{ fontSize: "48px", color: Colors.primary }} />
            <Typography>Total Jobs</Typography>
          </Box>
          <Typography>{jobs}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "16px", }}>
            <Summarize sx={{ fontSize: "48px", color: Colors.primary }} />
            <Typography>Total Proposals</Typography>
          </Box>
          <Typography>{proposals}</Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default RecentOrdersCard